// request for lazy loading for all pages

export default class qrData {
    SrNo = '';
    Qrdata = '';
}